import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NbButtonModule, NbCardModule, NbSpinnerModule } from '@nebular/theme';
import { AuthService } from '../../core/auth/auth.service';
import { DashboardIndicadores } from '../../core/api/dashboard-indicadores';
import { DashboardService } from '../../core/api/dashboard.service';
import { mensagemDeErro } from '../../utils/mensagem-erro';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterLink, NbCardModule, NbButtonModule, NbSpinnerModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  nome: string | null = null;
  showGestao = false;
  showAdmin = false;
  showMinhasTurmas = false;

  indicadores: DashboardIndicadores | null = null;
  indicadoresCarregando = true;
  indicadoresErro = false;
  /** Preenchido quando a API falha; o card continua visível. */
  indicadoresErroDetalhe: string | null = null;

  private readonly auth = inject(AuthService);
  private readonly dashboardService = inject(DashboardService);

  ngOnInit(): void {
    this.nome = this.auth.getNome();
    this.auth.ensurePerfil().subscribe(() => this.atualizarFlags());
    this.auth.perfil$.subscribe(() => this.atualizarFlags());
    this.carregarIndicadores();
  }

  carregarIndicadores(): void {
    this.indicadoresCarregando = true;
    this.indicadoresErro = false;
    this.indicadoresErroDetalhe = null;
    this.dashboardService.indicadores().subscribe({
      next: (d) => {
        this.indicadores = d;
        this.indicadoresCarregando = false;
        this.indicadoresErro = false;
      },
      error: (err: unknown) => {
        this.indicadoresCarregando = false;
        this.indicadoresErro = true;
        this.indicadores = null;
        // MSG-02/MSG-06: o texto é o do backend. Saíram o diagnóstico que a tela escrevia
        // sozinha (endpoint ausente, CORS) e o `message` técnico do Angular.
        this.indicadoresErroDetalhe = mensagemDeErro(err, 'Não foi possível carregar os indicadores.');
      },
    });
  }

  private atualizarFlags(): void {
    const p = this.auth.getPerfil();
    this.showGestao = !!(p?.admin || p?.coordenacao);
    this.showAdmin = !!p?.admin;
    this.showMinhasTurmas = !!p?.catequista;
  }

  /** Texto " — dd/mm/aaaa a dd/mm/aaaa" ou vazio. */
  get sufixoPeriodoSemanaAnterior(): string {
    const p = this.periodoSemanaAnterior();
    return p ? ` — ${p}` : '';
  }

  periodoSemanaAnterior(): string {
    const i = this.indicadores?.semanaAnteriorInicio;
    const f = this.indicadores?.semanaAnteriorFim;
    if (!i || !f) return '';
    return `${this.formatarDataBr(i)} a ${this.formatarDataBr(f)}`;
  }

  private formatarDataBr(iso: string): string {
    const p = iso.split('-');
    if (p.length !== 3) return iso;
    return `${p[2]}/${p[1]}/${p[0]}`;
  }
}
